import { Helmet } from 'react-helmet'
import ProgressSteps from './ProgressSteps'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Progress Steps</title>
    </Helmet>
    <ProgressSteps />
  </>
)
export default Wrapper
